import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-7",
  style: {"position":"relative","z-index":"1 !important","background-color":"#F4F6F9"}
}, null, -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "card-login col-12 col-sm-6 p-10 p-lg-20 banner_login_top position-relative pb-lg-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "red-shape",
    src: "/media/shape/red-shape.png",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "pink-shape",
    src: "/media/shape/pink-shape.png",
    alt: ""
  })
], -1)
const _hoisted_6 = { class: "banner_content d-flex flex-column justify-content-between h-100" }
const _hoisted_7 = { class: "text-center mb-10" }
const _hoisted_8 = { class: "text-dark-blue banner-title text-uppercase" }
const _hoisted_9 = { class: "fv-row mb-10 mt-0 mt-lg-20 pt-5" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "fv-row mb-10" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack mb-2" }, null, -1)
const _hoisted_14 = { class: "fv-plugins-message-container" }
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { class: "text-center h-25 d-flex flex-column" }
const _hoisted_17 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_sign_in_submit",
  class: "btn-sign-in btn btn-lg btn-dark-blue w-100 p-4 mb-5"
}
const _hoisted_18 = { class: "indicator-label text-uppercase" }
const _hoisted_19 = { class: "indicator-progress text-uppercase" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_21 = { class: "card-login col-12 col-sm-6 bg-dark-blue banner_login p-10 p-lg-20 pb-lg-5" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/logos/login_banner_img.png",
  alt: "",
  class: "login-banner_image"
}, null, -1)
const _hoisted_23 = { class: "banner_content d-flex flex-column justify-content-between h-100" }
const _hoisted_24 = { class: "text-white banner-title text-uppercase" }
const _hoisted_25 = { class: "text-white fs-2 mt-10" }
const _hoisted_26 = { class: "text-center h-25 text-uppercase" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_Form, {
          class: "form w-100 h-100",
          id: "kt_login_signin_form",
          onSubmit: _ctx.onSubmitLogin,
          "validation-schema": _ctx.login
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.translate("LOGIN_ACCESS_TOOL")), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Field, {
                    class: "form-control form-control-lg",
                    type: "text",
                    name: "email",
                    autocomplete: "off",
                    placeholder: _ctx.translate('LOGIN_USERNAME_EMAIL_PLACEHOLDER'),
                    label: _ctx.translate('LOGIN_USERNAME_EMAIL_PLACEHOLDER'),
                    "aria-required": "true"
                  }, null, 8, ["placeholder", "label"]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_ErrorMessage, { name: "email" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_Field, {
                    class: "form-control form-control-lg",
                    type: "password",
                    name: "password",
                    autocomplete: "off",
                    placeholder: "Password",
                    label: "Password",
                    "aria-required": "true"
                  }),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_ErrorMessage, { name: "password" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", _hoisted_17, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.translate("LOGIN_BUTTON")), 1),
                  _createElementVNode("span", _hoisted_19, [
                    _createTextVNode(_toDisplayString(_ctx.translate("BUTTON_WAIT")) + " ", 1),
                    _hoisted_20
                  ])
                ], 512),
                _createVNode(_component_router_link, {
                  to: "/password-reset-email",
                  class: "link-forgot-password link-primary fw-bolder text-uppercase"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.translate("LOGIN_FORGOT_PSW_LINK")), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", null, [
            _createElementVNode("h1", _hoisted_24, _toDisplayString(_ctx.translate("LOGIN_NO_ACCOUNT_MESSAGE")), 1),
            _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.translate("LOGIN_EDIT_REGISTRATION_INFO")), 1)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_router_link, {
              to: "/sign-up",
              class: "btn-sign-in btn btn-lg btn-white fw-bolder w-100 text-dark-blue btn-custom p-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.translate("LOGIN_REGISTER_LINK")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}